import { Plus, Trash2 } from 'lucide-react';
import { parseQuickLinks, serializeQuickLinks } from '../../utils/siteLabelsEditors';

const PAGE_OPTIONS = [
  { label: 'Home', path: '/' },
  { label: 'Events / Treks', path: '/events' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact', path: '/contact' },
  { label: 'Careers', path: '/careers' },
  { label: 'Blogs', path: '/blogs' },
  { label: 'Team', path: '/team' },
  { label: 'Dashboard (logged-in users)', path: '/dashboard' },
  { label: 'Terms', path: '/terms' },
  { label: 'Privacy', path: '/privacy' }
];

/**
 * @param {{ value: string, onChange: (json: string) => void }} props
 */
export default function FooterQuickLinksEditor({ value, onChange }) {
  const links = parseQuickLinks(value);

  const update = (next) => {
    onChange(serializeQuickLinks(next));
  };

  return (
    <div className="site-labels-visual">
      <p className="form-hint site-labels-visual-intro">
        Links in the footer “Quick Links” column. Choose a page from the list or enter a custom path starting with{' '}
        <code>/</code>.
      </p>
      <div className="site-labels-visual-rows">
        {links.map((link, index) => {
          const isPreset = PAGE_OPTIONS.some((o) => o.path === link.path);
          return (
            <div className="site-labels-visual-row" key={`ql-${index}`}>
              <label className="site-labels-visual-field">
                <span className="site-labels-visual-label">Link text</span>
                <input
                  type="text"
                  className="input"
                  value={link.label}
                  placeholder="e.g. About Us"
                  onChange={(e) => {
                    const next = [...links];
                    next[index] = { ...next[index], label: e.target.value };
                    update(next);
                  }}
                />
              </label>
              <label className="site-labels-visual-field site-labels-visual-field-grow">
                <span className="site-labels-visual-label">Page</span>
                <div className="site-labels-visual-path-row">
                  <select
                    className="input"
                    value={isPreset ? link.path : '__custom__'}
                    onChange={(e) => {
                      const next = [...links];
                      if (e.target.value === '__custom__') {
                        next[index] = { ...next[index], path: '/' };
                      } else {
                        next[index] = { ...next[index], path: e.target.value };
                      }
                      update(next);
                    }}
                  >
                    {PAGE_OPTIONS.map((o) => (
                      <option key={o.path} value={o.path}>
                        {o.label}
                      </option>
                    ))}
                    <option value="__custom__">Custom path…</option>
                  </select>
                  {!isPreset && (
                    <input
                      type="text"
                      className="input"
                      value={link.path}
                      placeholder="/your-page"
                      onChange={(e) => {
                        const next = [...links];
                        next[index] = { ...next[index], path: e.target.value };
                        update(next);
                      }}
                    />
                  )}
                </div>
              </label>
              <button
                type="button"
                className="btn btn-ghost site-labels-visual-remove"
                aria-label="Remove link"
                onClick={() => update(links.filter((_, i) => i !== index))}
                disabled={links.length <= 1}
              >
                <Trash2 size={18} />
              </button>
            </div>
          );
        })}
      </div>
      <button
        type="button"
        className="btn btn-secondary site-labels-visual-add"
        onClick={() => update([...links, { label: '', path: '/events' }])}
      >
        <Plus size={16} /> Add link
      </button>
    </div>
  );
}
